<template>
    <div style="font-size: 0.9rem">
        <div style="font-size: 0.8rem">空き状況</div>
        <div style="display: flex; flex-wrap: wrap; gap: 1px;">
            <div v-for="x in Data" :key="x[0]" style="text-align: center; width: 50px;">
                <div style="background: #D3D3D3;">{{ x[0] }}</div>
                <div style="background: #ECEEF1; font-family: sans-serif;">{{ x[1] }}</div>
            </div>
        </div>
        <div v-if="Loading">空き状況を取得しています</div>
        <div style="color:dimgray;">※既に予約済みの場合は空き無しと表示される可能性があります。</div>
        <div style="color:dimgray;">※休場日(△)を利用開始日に選択することはできません。</div>
    </div>
</template>

<script>
import { BookingController } from '../../assets/api/bookingController.js'
import Util from "../../assets/utility.js"

export default {
    props: {
        start: {
            type: Date
        },
        end: {
            type: Date
        }
    },
    data() {
        return {
            Loading: true,
            Data: [],
        }
    },
    mounted(){
        this.reload()
    },
    methods: {
        async reload(){
            if(!this.start || !this.end) return

            this.Loading = true
            let s = Util.getDateValue(this.start)
            let e = Util.getDateValue(this.end)

            let res = await new BookingController().getOverview(s, e, 3, false)
            if(!res.ok) return

            /** @type {BookingStatus[]} */
            let books = res.data

            let data = []
            for(let d=s; d.getTime()<=e.getTime(); d.setDate(d.getDate()+1)){
                
                let b = books.find(x=>x.bookingDate.getTime() == d.getTime())
                let v = "－"
                if(b != null){
                    if(b.freeCount > 0) v = b.isHoliday ? "△" : "〇"
                    else v = b.slotCount > 0 ? "×" : "－"
                }
                data.push([
                    Util.formatDate(d, "M/d"),
                    v,
                ])
            }
            this.Data = data
            this.Loading = false
        },
        formatData(d, format){
            if(!d) return ""
            return Util.formatDate(d, format)
        }
    },
}
</script>

<style scoped>
</style>
